import React, { useEffect, useState } from "react";
import { Button, InputGroup, Form } from "react-bootstrap";
import ExchangeIcon from "../IconBox/ExchangeIcon";
import {
  BlockchainApproveToken,
  BlockchainBuyToken,
  getUsdtBalance,
} from "../../../Web3/Connector";
import { ERROR, Success, Warning } from "../../../../utils/errors";
import { Spin } from "antd";
import config from "../../../../config";
import { useNavigate } from "react-router";
import Web3ModalProvider from "../Connectwallet/Web3ModalProvider";
import Transactionsubmitmodal from "../../Modals/transactionsubmitmodal";
// import { useWeb3ModalProvider } from '@web3modal/ethers/react';

const Swapform = ({
  setIsProcessing,
  usdtBalance,
  InfiTokenPrice,
  walletConnnected,
  UsdtContract,
  presaleContract,
  BuyInfiClose
}) => {
  const navigate = useNavigate();
  const _useWeb3ModalProvider = Web3ModalProvider();
  const [submitTransaction, setsubmitTransaction] = useState(false)
  const [UsdtAmount, setUsdtAmount] = useState(0);
  const [infiToken, setInfiToken] = useState(0);
  const [isApproved, setisApproved] = useState(false);
  const [ApproveInterval, setApproveInterval] = useState();
  const spaceRight = {
    paddingRight: "50px",
  };

  const onchangehandler = (e) => {
    const { value, name } = e.target;
    setisApproved(false);
    if (name == "infiToken") {
      setInfiToken(value);
      setUsdtAmount(parseFloat(value * InfiTokenPrice).toFixed(6));
    } else {
      setUsdtAmount(value);
      setInfiToken(parseFloat(value / InfiTokenPrice).toFixed(6));
    }
  };
  const handleOpenModal = () => {
    setsubmitTransaction(true);
  };

  const handleCloseModal = () => {
    setsubmitTransaction(false);
  };

  const setMax = () => {
    setUsdtAmount(usdtBalance);
    setInfiToken(parseFloat(usdtBalance / InfiTokenPrice).toFixed(6));
  };

  // const checkvalidation = () => {
  //   if (UsdtAmount <=0 || infiToken <=0) 
  //   Warning('Minimum purchase amount should be 1 USDT')
  //   console.log("UsdtAmount",UsdtAmount, infiToken);
  // }

  const approveToken = async () => {
    // checkvalidation()
    if (0 > parseFloat(UsdtAmount)) {
      Warning("Minimum purchase amount should be 1 USDT");
      return;
    }
    const res = await getUsdtBalance(
      walletConnnected,
      UsdtContract,
      presaleContract,
      _useWeb3ModalProvider
    );
    if (parseFloat(res?.balance || 0) < parseFloat(UsdtAmount)) {
      Warning("Insufficeint USDT for buy token");
      return;
    }

    setIsProcessing(true);

    if (parseFloat(res.allowance) >= parseFloat(UsdtAmount)) {
      setisApproved(true);
      setIsProcessing(false);
      return;
    }
    const approval = await BlockchainApproveToken({
      walletAddress: walletConnnected,
      UsdtContract: UsdtContract,
      presaleContract: presaleContract,
      UsdtAmount: UsdtAmount,
      walletProvider: _useWeb3ModalProvider,
    });

    if (approval.status) {
      const id = setInterval(async () => {
        await approvalCheck();
      }, 1000);

      setApproveInterval(id);
    } else {
      setIsProcessing(false);
      Warning(approval.message);
    }
  };

  useEffect(() => {
    if (isApproved) {
      console.log("Cleared interval..");
      clearInterval(ApproveInterval);
      buyToken();
    }
  }, [isApproved]);

  const approvalCheck = async () => {
    const res = await getUsdtBalance(
      walletConnnected,
      UsdtContract,
      presaleContract,
      _useWeb3ModalProvider
    );
    if (parseFloat(res.allowance) >= parseFloat(UsdtAmount)) {
      setisApproved(true);
      console.log("Approved interval..");
    } else {
      console.log("check approval : ");
      console.log({ UsdtAmount, allowance: res.allowance });
    }
  };

  const buyToken = async () => {
    // checkvalidation();
    setIsProcessing(true);
    const resBuy = await BlockchainBuyToken({
      walletAddress: walletConnnected,
      UsdtContract: UsdtContract,
      presaleContract: presaleContract,
      UsdtAmount: UsdtAmount,
      walletProvider: _useWeb3ModalProvider,
    });
    setIsProcessing(false);
    if (resBuy.status) {
      setisApproved(true);
      BuyInfiClose();
      handleOpenModal();
    //   setTimeout(() => {
    //     navigate(`${config.baseurl}dashboard`);
    //   }, 2000);
    } else {
      Warning(resBuy.message);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
  };
  return (
    <>
      <div className="Sawpform outlineField pb-3">
        <div className="text-center mb-3">
          <h2>Buys with USDT</h2>
        </div>
        <Form.Group>
          <Form.Label className="mb-1 small">
            <b>USDT Amount</b>
            <span className=""> Balance : {usdtBalance || 0} USDT</span>
          </Form.Label>
          <InputGroup className="mb-4">
            <Form.Control
              placeholder="0.00"
              aria-describedby="basic-addon2"
              style={spaceRight}
              className="rounded-2"
              value={UsdtAmount}
              name="UsdtAmount"
              onChange={onchangehandler}
              onKeyPress={(event) => { if (!/^\d*[.]?\d{0,1}$/.test(event.key)) { event.preventDefault(); } }} onPaste={handleChange}
            />
            <Button
              type="button"
              onClick={setMax}
              className="border-0 text-blue position-absolute end-0 bg-transparent rounded-2 z-3 cursor-pointer"
            >
              MAX
            </Button>
          </InputGroup>
        </Form.Group>
        <div className="exchangeIcon text-center">
          <Button variant="default" className="bg-transparent">
            <img
              src="assets/icons/refreshIcon.svg"
              alt=" refreshIcon"
              className=" refreshIcon"
              style={{ width: "45px", height: "45px" }}
            />
          </Button>
        </div>
        <Form.Group className="mb-4" style={{ marginTop: "-1px" }}>
          <Form.Label className="mb-1 small">INFI Token</Form.Label>
          <InputGroup className="mb-3">
            <Form.Control
              placeholder="0 $INFI"
              aria-describedby="basic-addon2"
              value={`${infiToken}`}
              name="infiToken"
              onChange={onchangehandler}
              onKeyPress={(event) => { if (!/^\d*[.]?\d{0,1}$/.test(event.key)) { event.preventDefault(); } }} onPaste={handleChange}

            />
          </InputGroup>
        </Form.Group>
        <small>Step 1. Approve USDT</small>
        <br />
        <small>Step 2. Buy INFI</small>

        {!isApproved && (
          <Button
            variant="primary"
            className="text-black w-100 fw-medium"
            onClick={approveToken}
          >
            Buy Now
          </Button>
        )}
        {isApproved && (
          <Button
            variant="primary"
            className="text-black w-100 fw-medium"
            onClick={buyToken}
          >
            Buy Now
          </Button>
        )}
      </div>
      <Transactionsubmitmodal submitTransaction={submitTransaction} handleCloseModal={handleCloseModal} text="It will take a few minutes to confirm the transaction."/>

    </>
  );
};

export default Swapform;
